// root mutations
export default {
  showNavBarList (state) {
    state.showBarList = true
  }
}
